class ResimoService {
    // eslint-disable-next-line class-methods-use-this
    public async fetchData(apiUrl: string) {
        return fetch(apiUrl)
            .then((response) => response.json());
    }
}

export default ResimoService;
